export default __webpack_public_path__ + "static/media/uni-chancellor-badge.25fbeb26.svg";